import dayjs from 'dayjs'
import ptBR from 'dayjs/locale/pt-br'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { Providers } from 'providers'
import Router from 'routes'
import { CheckoutGTM } from './global/components/GTM'
import { AppNavbar } from './global/components/Header'
import { UpdateNotification } from './global/components/UpdateNotification'
import { Toaster } from './global/components/ui/sonner'

export function App() {
    dayjs.extend(utc)
    dayjs.extend(timezone)
    dayjs.extend(advancedFormat)
    dayjs.extend(isSameOrAfter)
    dayjs.extend(isSameOrBefore)
    dayjs.extend(isBetween)
    dayjs.extend(customParseFormat)
    dayjs.extend(localizedFormat)
    dayjs.locale(ptBR)

    return (
        <Providers>
            <CheckoutGTM />
            <AppNavbar />
            <Router />
            <Toaster position="bottom-left" />
            <UpdateNotification />
        </Providers>
    )
}
